export let routes = [
  {
    path: '/x3-side-time-periods',
    name: 'x3-side-time-periods',
    component: () => import('@x3/js/side/time-periods/time-periods.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
  {
    path: '/x3-side-time-periods-edit',
    name: 'x3-side-time-periods-edit',
    component: () => import('@x3/js/side/time-periods/time-periods-edit.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsTimePeriods(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-time-periods',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
  xsTimePeriodsEdit(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-time-periods-edit',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
